import { Storage } from '@frontend/web-storage';

const CIPHER_TOKENS = {
  TOKEN: 'secretPassToken',
  NORMAL: 'secretPassNormal',
  USER_ID: 'secretPassUserId',
  PASSWORD: 'secretPassPassword'
};

const storage = new Storage({
  cipherTokens: CIPHER_TOKENS
});

export default storage;
